// Module
var code = "<div id=\":elementId\"> <h4>Analysis Level</h4> </div> ";
// Exports
export default code;